import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(5),
    height: "250px",
    position: "relative",
  },
  block: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  logo: {
    top: "15px",
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(5),
  },
  text: {
    marginBottom: theme.spacing(1),
  },
  button: {
    position: "relative",
    top: "100px",
    width: "120px",
  },
}));

export default useStyles;
